import { Breadcrumb, Divider, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CancelButton from '../../components/CancelButton'
import Head from '../../components/Head'
import Button from '../../components/UI/Button'
import Input from '../../components/UI/Input'
import { createOrUpdateServer, getServerById } from '../../services/distributors'
import { notificationError } from '../../services/notification'
import { HomeOutlined } from '@ant-design/icons'

function NewDistributorServer(props: { accessLevel: string }) {

  const {id, distributor} = useParams()

  const [form, setForm] = useState({
    distributorId: distributor,
    serverAlias: "",
    serverAddress: "",
    serverAddressPrivate: "",
    internalPortOverride: "",
    externalPortOverride: ""
  })

  const history = useNavigate()

  useEffect(() =>{
    (async () => {
      if(id) {
        const response = await getServerById({id: id})
        if(response) {
          setForm({
            ...form,
            serverAlias: response.serverAlias,
            serverAddress: response.serverAddress,
            serverAddressPrivate: response.serverAddressPrivate,
            internalPortOverride: response.internalPortOverride,
            externalPortOverride: response.externalPortOverride,
          })
        }
      }
    })()
  },[])

  const submit = async () => {
    if(!form.serverAlias) return notificationError('Please insert a valid alias')
    if(!form.serverAddress) return notificationError('Please insert a valid public address')
    if(!form.serverAddressPrivate) return notificationError('Please insert a valid private address')
    if(!id) await createOrUpdateServer(form)
    if(id) await createOrUpdateServer({id, ...form})
    history(-1)
  }

  const items = [
    {
      title:<a onClick={() => history('/welcome')} href='#'><HomeOutlined style={{fontSize: 18}} /></a>
    },
    {
      title: <a href='#'>Distributor Server</a>
    },
    {
      title:<a href='#'>Create or Edit</a>
    },
  ];

  function itemRender(route: any, params: any, items: any, paths: any) {
    const item = items.indexOf(route);
    if(item == 0) {
      return <span>{route.title}</span>
    } else if(item === 1) {
      return <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>{route.title}</span>
    } else if (item === 2) {
      return <span>{route.title}</span>
    }
  }

return (
  <>
   <div className="advanced-breadcrumb">
      <Breadcrumb itemRender={itemRender} items={items} />
    </div>
    <div className='new-distributor-server'>
      <Head title={id ? 'Edit Distributor Server' : 'New Distributor Server'}/>
      <div className='new-distributor-server__container'>
        <Divider orientation="left">
          <strong>
            Alias
          </strong>
        </Divider>
        <div className='new-distributor-server__container__row'>
          <Input
            label='Alias *'
            placeholder='Alias'
            value={form.serverAlias}
            onChange={(e: any) => setForm({...form, serverAlias: e.target.value})}
          />
        </div>
        <Divider orientation="left">
          <strong>
            Address
          </strong>
        </Divider>
        <div className='new-distributor-server__container__row'>
          <Input
            label='Public address *'
            placeholder='Public address'
            value={form.serverAddress}
            onChange={(e: any) => setForm({...form, serverAddress: e.target.value})}
          />
          <Input
            label='Private address *'
            placeholder='Private address'
            value={form.serverAddressPrivate}
            onChange={(e: any) => setForm({...form, serverAddressPrivate: e.target.value})}
          />
        </div>
        <Divider orientation="left">
          <strong>
            Port
          </strong>
        </Divider>
        <div className='new-distributor-server__container__row'>
          <Input
            label='Internal port override (optional)'
            placeholder='Internal port override'
            value={form.internalPortOverride}
            onChange={(e: any) => setForm({...form, internalPortOverride: e.target.value})}
          />
          <Input
            label='External port override (optional)'
            placeholder='External port override'
            value={form.externalPortOverride}
            onChange={(e: any) => setForm({...form, externalPortOverride: e.target.value})}
          />
        </div>
        <Divider />
        <div className="new-distributor-server__container__actions">
          <Button type="primary" onClick={() => submit()}> 
            <p id="save-button">Save</p>
          </Button>
          <CancelButton />
        </div>
      </div>
    </div>
    </>
    
  )
}

export default NewDistributorServer